import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "MassReviewIncentive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showIncentive)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "DriverButton Green MassReviewIncentiveButton",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startReview()))
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "lnr-pencil MassReviewIncentiveIcon" }, null, -1 /* CACHED */)),
          _createTextVNode(" Review " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.amountOfEnrolmentsDisplayText), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}